import { Box } from '@mui/material';
import React from 'react';
import ContactHeader from '../../components/contact/ContactHeader';
import ContactForm from '../../components/contact/ContactForm';
import { UserContext } from '../../context/UserContext';
import { CompanyContext } from '../../context/CompanyContext';
import PrimarySkeleton from '../../components/shared/loading/PrimarySkeleton';

const InternalContactPage = () => {
  const { user } = React.useContext(UserContext);
  const { company } = React.useContext(CompanyContext);
  return (
    <>
      {user && company ? (
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            mb: 12
          }}
        >
          <ContactHeader title="Contact the Energy Partners Platform Support Team" />
          <Box width={'70%'}>
            <ContactForm user={user} company={company} />
          </Box>
        </Box>
      ) : (
        <PrimarySkeleton width={'100%'} height={100} />
      )}
    </>
  );
};

export default InternalContactPage;
